import i18n from "i18next";
import {
  createTableColumn,
  Link,
  TableColumnDefinition,
  Tooltip,
  Text,
} from "@fluentui/react-components";
import useWindowSize from "../../helpers/useWindowSize";
import { ILSP3ResponseDto } from "../../Models/ILSP3ResponseDto";
import { useState } from "react";
import { IAddUserBedarfPosition } from "../../Models/IAddUserBedarfPosition";
import { baseUrl } from "../../helpers/constants";

function Lsp3AngleColumns(preiseSichtbar: boolean) {
  const [clickedArtikel, setClickedArtikel] = useState<
    IAddUserBedarfPosition | undefined
  >(undefined);
  const windowSize = useWindowSize();
  const columns: TableColumnDefinition<ILSP3ResponseDto>[] = [
    // ------------Artikel------------
    createTableColumn<ILSP3ResponseDto>({
      columnId: "artikelId",
      renderHeaderCell: () => {
        return (
          <Tooltip
            content={i18n.t<string>("artikelIdTooltip")}
            relationship="label"
          >
            <Text> {i18n.t<string>("artikelId")}</Text>
          </Tooltip>
        );
      },
      renderCell: (item) => {
        if (windowSize.width > 500) {
          return (
            <Tooltip
              content={i18n.t<string>("displayTechnicalData")}
              relationship="label"
            >
              <Link
                target="_blank"
                href={`${baseUrl}/quickfinder?guid=${
                  item.guid ?? item.artikel.guid
                }`}
              >
                {item.artikelId}
              </Link>
            </Tooltip>
          );
        } else {
          <div>
            <Text>{item.artikelId}</Text>
            <Text>
              {item.artikel ? item.artikel.benennungDE : item.benennungDE}
            </Text>
          </div>;
        }
      },
    }),
    // ------------ BENNENUNG -------------
    createTableColumn<ILSP3ResponseDto>({
      columnId: "benennungM1",
      renderHeaderCell: () => {
        return <Text> {i18n.t<string>("benennung")}</Text>;
      },
      renderCell: (item) => {
        return (
          <Text>
            {i18n.language.includes("de")
              ? item.artikel.benennungDE
              : item.artikel.benennungEN}
          </Text>
        );
      },
    }),
    // ------------maxAbtriebsmoment------------
    createTableColumn<ILSP3ResponseDto>({
      columnId: "maxAbtriebsmoment",
      renderHeaderCell: () => {
        return (
          <Tooltip
            relationship="label"
            content={i18n.t<string>("maxAbtriebsmomentTooltip")}
          >
            <Text>{i18n.t<string>("maxAbtriebsmomentCol")}</Text>
          </Tooltip>
        );
      },
      renderCell: (item) => {
        return (
          <Text>
            {item.maxAbtriebsmoment
              ? item.maxAbtriebsmoment?.toLocaleString()
              : "-"}
          </Text>
        );
      },
    }),
    // ------------profilAbtrieb------------
    createTableColumn<any>({
      columnId: "profilAbtrieb",
      renderHeaderCell: () => {
        return (
          <Tooltip
            relationship="label"
            content={i18n.t<string>("profilAbtriebTooltip")}
          >
            <Text>{i18n.t<string>("profilAbtriebCol")}</Text>
          </Tooltip>
        );
      },
      renderCell: (item) => {
        return <Text>{item.profilAbtrieb}</Text>;
      },
    }),
    // ------------durchmesserAbtrieb------------
    createTableColumn<any>({
      columnId: "durchmesserAbtriebId",
      renderHeaderCell: () => {
        return (
          <Tooltip
            relationship="label"
            content={i18n.t<string>("durchmesserAbtrieb")}
          >
            <Text>{i18n.t<string>("durchmesserCol")}</Text>
          </Tooltip>
        );
      },
      renderCell: (item) => {
        return <Text>{item.durchmesserAbtrieb}</Text>;
      },
    }),
    // ------------hoeheAbtrieb------------
    createTableColumn<any>({
      columnId: "hoeheAbtriebId",
      renderHeaderCell: () => {
        return (
          <Tooltip relationship="label" content={i18n.t<string>("hoehe")}>
            <Text>{i18n.t<string>("hoeheCol")}</Text>
          </Tooltip>
        );
      },
      renderCell: (item) => {
        return <Text>{item.hoehe}</Text>;
      },
    }),

    // ------------AchsWinkel------------
    createTableColumn<any>({
      columnId: "achswinkelAbtriebId",
      renderHeaderCell: () => {
        return (
          <Tooltip relationship="label" content={i18n.t<string>("achswinkel")}>
            <Text>{i18n.t<string>("AW[°]")}</Text>
          </Tooltip>
        );
      },
      renderCell: (item) => {
        return <Text>{item.achswinkel + "°"}</Text>;
      },
    }),
  ];
  if (preiseSichtbar) {
    columns.push(
      // ------------preis------------
      createTableColumn<ILSP3ResponseDto>({
        columnId: "preis",
        renderHeaderCell: () => {
          return (
            <Tooltip
              relationship="label"
              content={<div>{i18n.t<string>("preisTooltip")}</div>}
            >
              <Text>
                {i18n.t<string>("preis")}
                <Text style={{ color: "#ff6600", fontWeight: 700 }}>*</Text>
              </Text>
            </Tooltip>
          );
        },
        renderCell: (item) => {
          if (item.hasOwnProperty("artikel") && item.artikel) {
            return (
              <div className="lueb-centerVertical">
                <Text>
                  {item.artikel?.netto
                    ? item.artikel?.netto.toLocaleString(
                        i18n.language.includes("de") ? "de-DE" : "en-EN",
                        { minimumFractionDigits: 2 },
                      ) + " €"
                    : ""}
                </Text>
              </div>
            );
          } else {
            return (
              <div className="lueb-centerVertical">
                <Text>
                  {item.netto
                    ? item.netto.toFixed(2).toLocaleString() + " €"
                    : ""}
                </Text>
              </div>
            );
          }
        },
      }),
    );
  }
  return columns;
}
export default Lsp3AngleColumns;
